import "../../../assets/RideSelectTextField.css";
import t, { useState as v, cloneElement as m } from "react";
import u from "clsx";
import R from "lodash.uniqueid";
import { RideErrorMessage as q } from "../../atoms/error-message/RideErrorMessage.js";
import { RideSelect as A } from "../../atoms/select/RideSelect.js";
import { RideTextField as U } from "../../atoms/text-field/RideTextField.js";
import { RideSelectOld as j } from "../../atoms/select-old/RideSelectOld.js";
const w = "_label_1k33b_38", B = "_disabled_1k33b_59", l = {
  "ride-select-text-field": "_ride-select-text-field_1k33b_1",
  "select-input": "_select-input_1k33b_6",
  "child-select": "_child-select_1k33b_13",
  "select-size-small": "_select-size-small_1k33b_21",
  "select-size-medium": "_select-size-medium_1k33b_24",
  "child-text-field": "_child-text-field_1k33b_30",
  label: w,
  "helper-text": "_helper-text_1k33b_50",
  disabled: B
};
function W({
  "aria-label": n,
  children: S,
  className: T,
  "data-testid": $,
  disabled: i,
  error: N,
  errorMessage: E,
  helperText: k,
  id: g,
  label: c,
  loading: p,
  size: _ = "medium",
  selectSize: y = "medium",
  informativePopover: C
}) {
  const [z] = v(g ?? R(":ride:")), [a] = v(R(":ride:")), F = () => u(T, l["ride-select-text-field"], {
    [l.disabled]: i
  }), I = () => {
    if (!i && N && E)
      return /* @__PURE__ */ t.createElement(q, { message: E });
    if (k)
      return /* @__PURE__ */ t.createElement("p", { className: l["helper-text"] }, k);
  }, M = () => {
    const d = [], f = t.Children.toArray(S), o = f.find(
      (e) => t.isValidElement(e) && e.type === A
    ), b = f.find(
      (e) => t.isValidElement(e) && e.type === j
    ), x = f.find(
      (e) => t.isValidElement(e) && e.type === U
    );
    if (o) {
      const { value: e, options: r, className: h } = o.props, s = r && r[0];
      d.push(
        m(o, {
          className: u(
            h,
            l["child-select"],
            l[`select-size-${y}`]
          ),
          disabled: i || p,
          error: null,
          errorMessage: null,
          helperText: null,
          size: _,
          value: e ?? (s == null ? void 0 : s.value),
          "aria-labelledby": c ? a : null,
          "aria-label": n ? `select - ${n}` : null
        })
      );
    }
    if (!o && b) {
      const { value: e, options: r, className: h } = b.props, s = r && r[0];
      d.push(
        m(b, {
          className: u(
            h,
            l["child-select"],
            l[`select-size-${y}`]
          ),
          disabled: i || p,
          error: null,
          errorMessage: null,
          helperText: null,
          size: _,
          value: e ?? (s == null ? void 0 : s.value),
          "aria-labelledby": c ? a : null,
          "aria-label": n ? `select - ${n}` : null
        })
      );
    }
    if (x) {
      const { className: e } = x.props;
      d.push(
        m(x, {
          "aria-label": n ? `textfield - ${n}` : null,
          "aria-labelledby": c ? a : null,
          className: u(e, l["child-text-field"]),
          disabled: i,
          error: N,
          errorMessage: null,
          glyph: null,
          helperText: null,
          loading: p,
          size: _
        })
      );
    }
    return d;
  }, V = () => C ? m(C, { size: "small" }) : null;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": $,
      className: F(),
      id: z
    },
    c && /* @__PURE__ */ t.createElement("label", { id: a, className: l.label }, c, " ", V()),
    /* @__PURE__ */ t.createElement("div", { className: l["select-input"] }, M()),
    I()
  );
}
export {
  W as RideSelectTextField
};
